import { render, staticRenderFns } from "./PurchaseAttention.vue?vue&type=template&id=380f5201&"
import script from "./PurchaseAttention.vue?vue&type=script&lang=js&"
export * from "./PurchaseAttention.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports